import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const WaitlistAssignIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="#001A19"
    title={t`Waitlist Assign`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="M4 12.25a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h3Zm5.97-4.78a.75.75 0 1 1 1.06 1.06L9.81 9.75H15a.75.75 0 0 1 0 1.5H9.81l1.22 1.22a.75.75 0 0 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5ZM5.5 7.25a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h4.5Zm9.5-5a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h14Z"
    />
  </Icon>
);
